import React from "react";
import { Pencil } from "lucide-react";
import { TspCard, TspTable, TspBadge } from "../../../components/primitives";

// Recorded visits, newest first, one page at a time (`meta` is the API's paging).
// With `onEdit` (the caller may manage visits), each visit of a journey still in
// progress gets an Edit button.
export default function CityVisitHistoryCard({ records, meta, onPageChange, onEdit }) {
  const columns = [
    { key: "date", label: "Date" },
    { key: "time", label: "Time" },
    { key: "journey", label: "Journey" },
    { key: "city", label: "City" },
    {
      key: "areasVisited",
      label: "Areas Visited",
      render: (row) => (
        <span className="tsp-chip-row">
          {row.areasVisited.map((area) => (
            <TspBadge key={area} tone="neutral">
              {area}
            </TspBadge>
          ))}
        </span>
      ),
    },
    { key: "gps", label: "GPS", render: (row) => row.gps || "—" },
    { key: "remarks", label: "Remarks" },
  ];
  if (onEdit) {
    columns.push({
      key: "actions",
      label: "Actions",
      align: "right",
      render: (row) =>
        row.editable ? (
          <button type="button" className="tsp-btn tsp-btn-outline-primary tsp-btn-sm" onClick={() => onEdit(row.id)} aria-label={`Edit visit to ${row.city} on ${row.date}`}>
            <Pencil size={12} aria-hidden="true" /> Edit
          </button>
        ) : (
          <span className="tsp-muted-text" title="The journey is no longer in progress">
            —
          </span>
        ),
    });
  }

  return (
    <TspCard title="Visit History" action={<span className="tsp-muted-text">{meta.total} visits</span>}>
      {records.length === 0 ? <p className="tsp-muted-text">No city visits have been recorded yet.</p> : <TspTable columns={columns} rows={records} rowKey="id" />}
      {meta.totalPages > 1 && (
        <div className="tsp-table-pagination">
          <span>
            Page {meta.page} of {meta.totalPages}
          </span>
          <span className="tsp-card-action-group">
            <button type="button" className="tsp-btn tsp-btn-outline tsp-btn-sm" disabled={meta.page <= 1} onClick={() => onPageChange(meta.page - 1)}>
              Previous
            </button>
            <button type="button" className="tsp-btn tsp-btn-outline tsp-btn-sm" disabled={meta.page >= meta.totalPages} onClick={() => onPageChange(meta.page + 1)}>
              Next
            </button>
          </span>
        </div>
      )}
    </TspCard>
  );
}
